import React from 'react';

const CharChooseBtn = (props) => (
    <div 
        key={props.index} 
        id={props.label} 
        className={props.selected ? "char-btn on" : "char-btn up"}
        style={{backgroundImage: `url(./images/sections/${props.charType}/chars/${props.selected ? `on` : `up`}/` + props.label + `.svg)`}}
        onClick={props.onClick}
    ></div>
);

export default CharChooseBtn;



// WEBPACK FOOTER //
// ./src/components/sections/shared/CharChooseBtn.js